import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "rnt_admin_token";
const VISITOR_KEY = "rnt_visitor_id";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getVisitorId() {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) {
    v =
      (crypto?.randomUUID && crypto.randomUUID()) ||
      `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(VISITOR_KEY, v);
  }
  return v;
}

export async function trackPageView(path = "/") {
  try {
    await axios.post(`${API}/track/pageview`, {
      visitor_id: getVisitorId(),
      path,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    });
  } catch (e) {
    // silent
  }
}

export async function trackCtaClick(ctaId = "join-telegram") {
  try {
    await axios.post(`${API}/track/cta-click`, {
      visitor_id: getVisitorId(),
      cta_id: ctaId,
      user_agent: navigator.userAgent,
    });
  } catch (e) {
    // silent
  }
}
